<script>
	export let title = "Sharing icon";
</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.83 65.86" role="img">
	<title>{title}</title>
	<path
		d="M45.39,65.02H3.33c-1.64,0-2.97-1.33-2.97-2.97V22.62c0-1.64,1.33-2.97,2.97-2.97H20.42v3.31H3.67V61.71H45.05V22.96H28.3v-3.31h17.09c1.64,0,2.97,1.33,2.97,2.97V62.05c0,1.64-1.33,2.97-2.97,2.97Z" />
	<path
		d="M37.12,12.49L25.29,.66c-.52-.52-1.35-.52-1.86,0L11.6,12.49c-.52,.51-.52,1.34,0,1.86,.51,.52,1.34,.52,1.86,0L23.05,4.76v31c0,.72,.59,1.31,1.31,1.31s1.31-.59,1.31-1.31V4.76l9.59,9.58c.51,.52,1.34,.52,1.86,0,.51-.51,.51-1.34,0-1.86" />
</svg>
